type TimelineExecutionDisplayInput = {
  agentName: string | null;
  threadId: string | null;
  title: string;
};

export function isInternalStoryTraceLabel(value?: string | null): boolean {
  if (!value) {
    return false;
  }

  const normalized = value.toLowerCase().replace(/[\s_-]/g, '');

  return normalized === 'copilotstory';
}

export function getFindingTimelineExecutionDisplayText({
  execution,
  executionLabel,
}: {
  execution: TimelineExecutionDisplayInput;
  executionLabel: string;
}): string {
  const title = execution.title.trim();
  const agentName = execution.agentName || 'agent';

  if (
    isInternalStoryTraceLabel(title) ||
    isInternalStoryTraceLabel(agentName)
  ) {
    return executionLabel;
  }

  if (title && title !== agentName && !title.startsWith('Trace ')) {
    return title;
  }

  const shortThreadId = execution.threadId?.slice(0, 8) || '';

  return shortThreadId ? `${agentName} • ${shortThreadId}` : agentName;
}

export function resolveExecutionOpenTitle({
  title,
  agentName,
}: {
  title?: string | null;
  agentName?: string | null;
}): string | undefined {
  if (
    isInternalStoryTraceLabel(title) ||
    isInternalStoryTraceLabel(agentName)
  ) {
    return undefined;
  }

  const trimmed = title?.trim();

  return trimmed && trimmed.length > 0 ? trimmed : undefined;
}
